import React from "react";
import CultureContent from "../FunctionComponents/CultureFolder/CultureContent";

function Culture() {
  return (
    <>
      <CultureContent />
    </>
  );
}

export default Culture;
